import MembershipCodes from "@/pages/membership/MembershipCodes";
import MemberPins from "@/pages/membership/MemberPins";

const TABS = [["membership_codes", "Membership Codes"], ["member_pins", "Member PINs"]];

// Codes and PINs: the two existing pages as tabs; each tab shows only with access.
export default function CodesPins({ active, allowed, onTab }) {
  const tabs = TABS.filter(([id]) => allowed.includes(id));
  return (
    <div data-testid="codes-pins-page">
      {tabs.length > 1 && (
        <div className="flex gap-2 mb-5 border-b border-ink/15" data-testid="codes-pins-tabs">
          {tabs.map(([id, label]) => (
            <button key={id} data-testid={`codes-pins-tab-${id}`} onClick={() => onTab(id)}
              className={`px-4 py-2.5 -mb-px text-[15px] font-semibold border-b-2 transition-colors ${active === id ? "border-maroon text-maroon" : "border-transparent text-ink/60 hover:text-ink"}`}>
              {label}
            </button>
          ))}
        </div>
      )}
      {active === "member_pins" ? <MemberPins /> : <MembershipCodes />}
    </div>
  );
}
